<template>
    <div class="apprentice-simple-card">
        <h3 class="title">{{ $t('user_account.sign_in.by_school') }}</h3>
        <div class="description">
            {{
                $t(
                    'user_account.sign_in.this_link_ensures_that_you_can_log_in_with_your_own_school_account_in_the_portal',
                )
            }}
        </div>

        <div
            class="linked"
            v-if="this.userIn.kennisnet_account">
            <div class="status">
                <span class="label">Status:</span>
                <b-badge variant="success">{{ this.userIn.kennisnet.account.signin.linked }}</b-badge>
            </div>
            <p class="hidden">Kennisnet id: {{ this.userIn.kennisnet_account.kennisnet_id }}</p>
            <b-button
                class="btn-unlink-school-account"
                variant="outline-danger"
                @click="samlReset()">
                <i class="fas fa-unlock icon"></i>{{ $t('user_account.sign_in.disconnect_school_account') }}
            </b-button>
        </div>

        <div v-else>
            <div class="status">
                <span class="label">Status:</span>
                <b-badge variant="danger">{{ $t('user_account.sign_in.not_connected') }}</b-badge>
            </div>
            <div class="info-text">
                {{ $t('user_account.sign_in.link_school_to_account_explanation') }}
            </div>

            <b-button
                class="btn-link-school-account"
                variant="outline-primary"
                @click="samlLogin()">
                <i class="fas fa-lock icon"></i>{{ $t('user_account.sign_in.connect_school_account') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-user-account-school-signin-component',
    props: ['userIn'],
    methods: {
        samlReset() {
            window.location.href = this.routes.baseUrl() + '/reset/saml2/';
        },

        samlLogin() {
            window.location.href = this.routes.baseUrl() + '/saml2/login/';
        },
    },
};
</script>

<style scoped lang="scss">
.title {
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
}

.description {
    margin-bottom: $grid-gutter-width;
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    font-size: $base-font-size;
}

.status {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .badge {
        color: $white;
        font-size: $default-font-size;
        margin-left: map-get($grid-gutter-spacing, 'ten');
    }
}

.btn-link-school-account,
.btn-unlink-school-account {
    font-size: $default-font-size;

    .icon {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.info-text {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
